import { useEffect, useState } from "react";

/** Bootstrap lg breakpoint — matches app shell nav drawer. */
export const MOBILE_BREAKPOINT = 991.98;
export const TABLET_BREAKPOINT = 767.98;

export function useMediaQuery(query: string): boolean {
	const [matches, setMatches] = useState(() => {
		if (typeof window === "undefined") return false;
		return window.matchMedia(query).matches;
	});

	useEffect(() => {
		const mq = window.matchMedia(query);
		const onChange = () => setMatches(mq.matches);
		onChange();
		mq.addEventListener("change", onChange);
		return () => mq.removeEventListener("change", onChange);
	}, [query]);

	return matches;
}

export function useIsMobile(): boolean {
	return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT}px)`);
}

export function useIsTablet(): boolean {
	return useMediaQuery(`(max-width: ${TABLET_BREAKPOINT}px)`);
}
